import { ContactField } from '@dev/ee-api/ee-api-models';

import {
    GetContactFieldsParams,
    GetContactFieldsStartAction,
    GetContactFieldsErrorAction,
    GetContactFieldsSuccessAction,
    PutContactFieldStartAction,
    PutContactFieldErrorAction,
    PutContactFieldSuccessAction,
    DeleteContactFieldStartAction,
    DeleteContactFieldErrorAction,
    DeleteContactFieldSuccessAction,
    SetCustomFieldAction,
    SetCollectionAction,
    GetRecognizedFields,
    SetRecognizedFields,
    NewFieldInterface,
    SetCurrentFieldTypeAction,
    CustomFieldsInterface,
} from './types';
import { ApplicationState } from '..';

export const GetContactFieldsStart = (params?: GetContactFieldsParams): GetContactFieldsStartAction => ({
    type: '@@contactfields/FETCH_START',
    payload: {
        ...params,
        isLoadingFields: true,
    },
});

export const GetContactFieldsError = (): GetContactFieldsErrorAction => ({
    type: '@@contactfields/FETCH_ERROR',
    payload: {
        isLoadingFields: false,
        isLoadedFields: true,
    },
});

export const GetContactFieldsSuccess = (collection: ContactField[]): GetContactFieldsSuccessAction => ({
    type: '@@contactfields/FETCH_SUCCESS',
    payload: {
        isLoadingFields: false,
        isLoadedFields: true,
        collection,
    },
});

export const PutContactFieldStart = (contactField: ContactField, currentFieldType: string): PutContactFieldStartAction => ({
    type: '@@contactfields/CREATE_START',
    payload: {
        isAddingField: true,
        contactField,
        currentFieldType,
    },
});

export const PutContactFieldError = (currentFieldType: string, nameFieldBackendError?: string): PutContactFieldErrorAction => ({
    type: '@@contactfields/CREATE_ERROR',
    payload: {
        isAddingField: false,
        currentFieldType,
        nameFieldBackendError,
    },
});

export const SetCurrentFieldType = (currentFieldType: string): SetCurrentFieldTypeAction => ({
    type: '@@contactfields/SET_CURRENT_FIELD_TYPE',
    payload: {
        currentFieldType,
    },
});

export const PutContactFieldSuccess = (collection: ContactField[], currentFieldType: string): PutContactFieldSuccessAction => ({
    type: '@@contactfields/CREATE_SUCCESS',
    payload: {
        isAddingField: false,
        collection,
        newField: {
            Name: '',
            Length: null,
            Type: null,
        },
        currentFieldType,
    },
});

export const DeleteContactFieldStart = (name: string): DeleteContactFieldStartAction => ({
    type: '@@contactfields/DELETE_START',
    payload: {
        name,
    },
});

export const DeleteContactFieldError = (): DeleteContactFieldErrorAction => ({
    type: '@@contactfields/DELETE_ERROR',
});

export const DeleteContactFieldSuccess = (collection: ContactField[]): DeleteContactFieldSuccessAction => ({
    type: '@@contactfields/DELETE_SUCCESS',
    payload: {
        collection,
        selectedFieldName: null,
    },
});

export const SetContactFieldCollection = (visibleSet: ContactField[]): SetCollectionAction => ({
    type: '@@contactfields/SET_COLLECTION',
    payload: {
        visibleSet,
    },
});

export const SetCustomField = (newField: NewFieldInterface): SetCustomFieldAction => ({
    type: '@@contactfields/SET_CUSTOM_FIELD',
    payload: {
        newField,
    },
});

export const GetFields = (allFields: number, recognizedFields: number): GetRecognizedFields => ({
    type: '@@contactfields/GET_FIELDS',
    payload: {
        allFields,
        recognizedFields,
    },
});

export const SetFields = (allFields: number, recognizedFields: number): SetRecognizedFields => ({
    type: '@@contactfields/SET_FIELDS',
    payload: {
        allFields,
        recognizedFields,
    },
});

export const getCustomFieldsStore = (state: ApplicationState): CustomFieldsInterface => state.customFields;
